export const RSInspectionApiEndpointConstants = {
    GetRequestedInspectorCountries: "GetRequestedInspectorCountries",
    GetRequestedInspectors: "GetRequestedInspectors",
    SubmitProposal: "SubmitProposal",
    SaveInspectionProposal: "SaveInspectionProposal",
    GetInspectionProposalDetails: "GetInspectionProposalDetails",
    GetInspectionProposalInspectionInfo: "GetInspectionProposalInspectionInfo",
    GetInspectionInvoiceSubmissionInfo: "GetInspectionInvoiceSubmissionInfo",
    SubmitRightShipInspectionInvoice: "SubmitRightShipInspectionInvoice",
    GetRightShipInspectionDetails: "GetRightShipInspectionDetails",
    GetReviseProposalInspection: "GetReviseProposalInspection",
    GetCurrentUserInfo: "GetCurrentUserInfo",
    SubmitReviseOfferProposalInspection: "SubmitReviseOfferProposalInspection",
    SubmitWithdrawalProposalInspection: "SubmitWithdrawalProposalInspection",
    RescheduleInspection: "RescheduleInspection",
    GetInspectionOutcomeReportModel: "GetInspectionOutcomeReportModel",
}